// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-color-button{pointer-events:none;font-size:2rem;line-height:0}\n", ""]);
// Exports
module.exports = exports;
